import { api } from "jiffy-api";
import "common/jiffy/cable";
import { objNamesToCamelCase } from "common/utils/helpers/cases";

export default class DesignUploadCtaPlpFileUploadChannel {
  static async channelUuid() {
    const response = await api.dtf.getInitConfig({ catalog_number: "DTF001" });
    const { dtfChannelUuid } = objNamesToCamelCase(response);

    return dtfChannelUuid;
  }

  #uuid;

  #state = {};

  #onReceived;

  #onCompleted;

  #onError;

  constructor(uuid) {
    this.#uuid = uuid;
  }

  get uuid() {
    if (this.#uuid) return this.#uuid;

    throw new Error("UUID is not set. Please call channelUuid() to get the UUID.");
  }

  set onReceived(callback) {
    if (typeof callback === "function") {
      this.#onReceived = callback;
    } else {
      throw new Error("onReceived must be a function.");
    }
  }

  set onError(callback) {
    if (typeof callback === "function") {
      this.#onError = callback;
    } else {
      throw new Error("onError must be a function.");
    }
  }

  set onCompleted(callback) {
    if (typeof callback === "function") {
      this.#onCompleted = callback;
    } else {
      throw new Error("onCompleted must be a function.");
    }
  }

  // eslint-disable-next-line max-lines-per-function
  addSubscription() {
    const params = { uuid: this.#uuid, channel: "DtfChannel" };
    const { App } = window;
    const self = this;

    App.cable.subscriptions.create(params, {
      received(data) {
        const { result, action } = data;

        if (
          result.error &&
          [
            "upload_artwork",
            "process_lightweight_artwork",
            "process_artwork",
            "validate_artwork"
          ].includes(action)
        ) {
          self.#onError?.(result.error);
        }

        self.#onReceived?.(data);

        if (action === "upload_artwork") {
          this.perform("process_dtf_artwork", data.data);
        }

        if (["process_lightweight_artwork", "process_artwork"].includes(action)) {
          self.#onCompleted?.(result.process_data);
        }

        self.#state.lastWebSocketEvent = data.action;
        self.#state.lastWebSocketEventData = {
          result: data.result?.process_data || data.data,
          data: data.result?.data || data.data
        };
      },
      connected() {
        const { lastWebSocketEvent, lastWebSocketEventData, actionCableConnected } = self.#state;
        if (actionCableConnected) return;

        if (lastWebSocketEvent && Object.keys(lastWebSocketEventData).length > 0) {
          // Reset artwork processTimeStamp
          // There will be cases where discontinued continue sending messages.
          // Rejecting it to prioritize messages coming from this process since
          // this is the source of truth.
          const processTimeStamp = Date.now();
          this.perform("continue_dtf_artwork_process", {
            last_process: lastWebSocketEvent,
            last_process_data: lastWebSocketEventData.result,
            data: { ...lastWebSocketEventData.data, processTimeStamp }
          });

          self.#state.lastWebSocketEvent = null;
          self.#state.lastWebSocketEventData = {};
        }
      },
      disconnected: () => console.info("DTF Channel disconnected")
    });
  }
}
